export const ErrorField = {
    baseStyle: {
        color: "red",
        fontSize: "12px",
    },
};